import { render, staticRenderFns } from "./info-continue-button.vue?vue&type=template&id=49628b85"
import script from "./info-continue-button.vue?vue&type=script&lang=js"
export * from "./info-continue-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports